module.exports = __webpack_public_path__ + "static/media/picture-(228).a39af5c9.JPG";